/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge } from 'react-shimmer-effects'

export default function ViewSkeleton() {
    return (
        <div className="w-full overflow-x-hidden pt-4 pr-4 pb-[40px] pl-2">
            <div className="mb-6 flex flex-wrap items-start justify-between gap-x-8 gap-y-2">
                <p className="min-w-0 flex-1"><ShimmerBadge width={220} /></p>
                <ShimmerBadge width={160} />
            </div>
            <div className="mb-6 flex flex-wrap items-start justify-between gap-x-8 gap-y-2">
                <p className="min-w-0 flex-1"><ShimmerBadge width={260} /></p>
                <ShimmerBadge width={275} height={48} />
            </div>
            <div className="mb-6 flex flex-wrap items-start justify-between gap-x-8 gap-y-2">
                <p className="min-w-0 flex-1"><ShimmerBadge width={220} /></p>
                <ShimmerBadge width={90} height={26} />
            </div>
            <div className="mb-6 flex flex-wrap items-start justify-between gap-x-8 gap-y-2">
                <p className="min-w-0 flex-1"><ShimmerBadge width={220} /></p>
                <ShimmerBadge width={90} height={26} />
            </div>
            <div className="mb-6 flex flex-wrap items-start justify-between gap-x-8 gap-y-2">
                <p className="min-w-0 flex-1"><ShimmerBadge width={280} /></p>
                <ShimmerBadge width={220} height={20} />
            </div>
        </div>
    )
}
